import React from "react";
import { t } from "i18next";

type CreerCompteProps = {
    width?: number | string;
    height?: number | string;
    selectedLanguage?: string;
};

export function CreerCompte(props: CreerCompteProps): JSX.Element {
    const label = t("Create an account", { lng: props.selectedLanguage });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 350 87"
            role="img"
            aria-label={label}
        >
            <title>{label}</title>
            <g id="CreerCompte" data-name="CreerCompte">
                <rect
                    width="350"
                    height="87"
                    rx="9"
                    fill="none"
                    stroke="#323333"
                    strokeWidth="2"
                />
                <text
                    x="175"
                    y="58"
                    textAnchor="middle"
                    fill="#323333"
                    fontSize="34"
                    fontFamily="HelveticaNeue-Medium, Helvetica Neue"
                    fontWeight="500"
                >
                    {label}
                </text>
            </g>
        </svg>
    );
}
